import axios from 'axios'
import { getFirstErrorMessage, getErrorMessage, getErrorMessages, getErrorMessagesWithKeys } from '~/lib/axios'
import config from '../lib/config'
const {APIURI} = config

export default {
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,
  getErrorMessagesWithKeys,
  async getBookingAvailability(date) {
    const { data } = await axios.get(`${APIURI}/availability`, { params: {date}});
    const { bookings = [] } = data
    return bookings;
  },
  async login(request) {
    const { data } = await axios.post(`${APIURI}/login`, request);
    return data;
  },
  async logout(request) {
    const { data } = await axios.post(`${APIURI}/logout`, request);
    return data;
  },
  async register(request) {
    const { data } = await axios.post(`${APIURI}/register`, request);
    return data;
  },
  async myMemberships(request) {
    const { data: {memberships = []} = {} } = await axios.post(`${APIURI}/memberships`, request);
    return memberships
  },
  async hold(slot, quantity) {
    slot = _.clone(slot)
    if (quantity) {
      slot.quantity = quantity
    }
    const { data = {} } = await axios.post(`${APIURI}/slot/hold`, {slot});
    return data
  },
  async unhold(slots) {
    try {
      const { data = {} } = await axios.post(`${APIURI}/slot/unhold`, {slots});
      return data
    } catch (e) {

    }
    return false
  },
  async order(request) {
    const { data } = await axios.post(`${APIURI}/order`, request);
    return data;
  },
  async pay(request) {
    const { data } = await axios.post(`${APIURI}/pay`, request);
    return data;
  },
  async reserveRaceSlot(request) {
    const { data } = await axios.post(`${APIURI}/races/reserve-slot`, request);
    return data;
  },
  async releaseReservedRaceSlot(request) {
    const { data } = await axios.post(`${APIURI}/races/release-reserved-slot`, request);
    return data;
  },
  async buyClubspeedProduct(request) {
    const { data } = await axios.post(`${APIURI}/product/buy`, request);
    return data;
  },
  async myAccount(request) {
    const { data } = await axios.post(`${APIURI}/profile`, request);
    return data;
  },
  async grabMyProduct(request) {
    const { data } = await axios.post(`${APIURI}/product/grab`, request);
    return data;
  },

}
